const session = {
  state: {
    // 菜单样式
    thumb: 1,
    // 当前模块:menu对象
    module: {},
    // 菜单列表
    menuList: [],
    // 页面控件列表
    controlList: [],
    // 字典集合
    dictMap: {}
  },

  mutations: {
    SET_SESSION_THUMB: (state, data) => {
      state.thumb = data
    },
    SET_SESSION_MODULE: (state, data) => {
      state.module = data
    },
    SET_SESSION_MENU_LIST: (state, data) => {
      state.menuList = data
    },
    SET_SESSION_CONTROL_LIST: (state, data) => {
      state.controlList = data
    },
    SET_SESSION_DICT_MAP: (state, data) => {
      state.dictMap = data
    }
  },
  actions: {
    setSessionThumb ({commit}, data) {
      commit('SET_SESSION_THUMB', data)
    },
    setSessionModule ({commit}, data) {
      commit('SET_SESSION_MODULE', data)
    },
    setSessionMenuList ({commit}, data) {
      commit('SET_SESSION_MENU_LIST', data)
    },
    setSessionControlList ({commit}, data) {
      commit('SET_SESSION_CONTROL_LIST', data)
    },
    setSessionDictMap ({commit}, data) {
      commit('SET_SESSION_DICT_MAP', data)
    }
  }
}

export default session
